import Link from "next/link";
import autowertBestimmen from "../../../assets/auto-bewerten/Gebrauchtwagenbewertung.avif";
import Image from "next/image";

export const CarValueBoxes = () => {
  return (
    <div className="CarValueBoxes">
      <div className="CVB-left">
        <Image
          src={autowertBestimmen}
          alt="Wie viel ist dein Auto wert"
          className="autowertbestimmen"
        />
        <div className="CVB-left-text-wrapper">
          <h2>Autowert online berechnen – kostenlos und sofort</h2>
          <p>
            Der Wert deines Autos hängt stark von Marke und Modell ab und
            variiert je nach Alter, Zustand, Kilometerstand, Kraftstoffart,
            Einhaltung von Effizienzstandards, Marktnachfrage und anderen
            externen Faktoren. Den zukünftigen Wert deines Autos zu
            prognostizieren, ist komplex – aber das Bewertungstool von
            Autoeinfachlos übernimmt diese Aufgabe für dich, sofort und
            kostenlos.
          </p>
          <p>
            Im Ratgeber{" "}
            <Link
              href="/auto-bewerten/ratgeber/was-ist-mein-auto-wert"
              className="CVB-link"
            >
              Was ist mein Auto wert?
            </Link>{" "}
            liest du nach, welche Faktoren den Preis bestimmen und wie sich der
            Wert deines Autos voraussichtlich verändern wird.
          </p>
        </div>
      </div>
      <div className="CVB-right">
        <div className="CVB-right-first">
          <div className="CVB-right-first-text-wrapper">
            <h2>Wie wir dein Auto bewerten</h2>
            <p>
              Wir bewerten dein Auto anhand aktueller und historischer
              Marktdaten. Unsere umfangreiche Datenbank ermöglicht den Zugriff
              auf vergangene Entwicklungen. Dabei vergleichen wir Marke, Modell,
              Baujahr, Kilometerstand und weitere Kriterien deines Fahrzeugs mit
              ähnlichen Autos. So stellen wir sicher, dass unsere Bewertungen
              stets so aktuell und präzise wie möglich sind.
            </p>
            <p>
              Anhand deiner Fahrgestellnummer und des Kilometerstands erstellen
              wir eine Bewertung, die auf der individuellen Historie deines
              Fahrzeugs basiert – für eine zuverlässige Einschätzung, der du
              jetzt und in Zukunft vertrauen kannst.
            </p>
          </div>
        </div>

        <div className="CVB-right-second">
          <div className="CVB-right-second-text-wrapper">
            <h2>Warum Auto bewerten?</h2>
            <p>
              Egal, ob du dein Auto heute oder später verkaufen möchtest – eine
              genaue Autobewertung von einer vertrauenswürdigen Quelle ist für
              jeden Autobesitzer wichtig.
            </p>
            <p>
              Ob Benziner, Diesel, Hybrid oder Elektro: Den Wert deines Autos
              und dessen Wertverlust zu kennen, ist der erste Schritt, um den
              richtigen Zeitpunkt zu finden – und den besten Preis zu erzielen!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
